import { defineStore } from "pinia";

export const useInvoiceStore = defineStore("invoice", {
  state: () => ({
    invoiceFilters: {
      number: '',
      client: '',
      status: 'overdue',
      amountMin: '',
      amountMax: '',
      page: 1,
      itemsPerPage: 20,
    },
  }),
  actions: {
    setInvoiceFilters(filters) {
      this.invoiceFilters = { ...this.invoiceFilters, ...filters };
    },
  },
});
